export default __webpack_public_path__ + "static/media/LexusBG.077a5616.png";